import { getAllProcessedPayslipsOfUser } from "@/api/payslips";
import DataTable from "@/components/ui/DataTable";
import { useCurrentUser } from "@/context/UserContext";
import { AggregatePayslip } from "@/models/payslips.model";
import React, { useEffect, useState } from "react";
import { columns } from "./columns";
import { PayslipToolbar } from "./PayslipToolbar";

function PayslipDataTable() {
  const { currentUser } = useCurrentUser();
  const [data, setData] = useState<AggregatePayslip[]>([]);

  useEffect(() => {
    const getData = async () => {
      if (!currentUser) return;
      const data = await getAllProcessedPayslipsOfUser(
        currentUser.id as number
      );
      setData(data);
    };
    getData();
  }, [currentUser]);

  if (!currentUser) return <div>Loading...</div>;
  return (
    <div className="flex-1 min-h-0">
      <DataTable
        tableMinWidth="600px"
        Toolbar={PayslipToolbar}
        containerClassname="w-full h-full flex-1"
        data={data}
        columns={columns}
        tableCaption={`A total of ${data.length} processed payslips.`}
      />
    </div>
  );
}

export default PayslipDataTable;
